"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateLevelProperties = exports.isLevelPropertiesUnchanged = exports.getDeltaChangeState = exports.patchDelta = exports.patchMeta = exports.getLevelFeaturesByLevelId = exports.getOutlineAsLine = exports.getNewFeatureId = exports.createLevelGeometry = exports.updateEntrancePosition = exports.getPointOnLine = exports.updateStackIndex = exports.createEntranceFeature = exports.createSpaceFeature = exports.simplifyEntranceRules = exports.simplifySpaceRules = exports.createSiteFeature = exports.createStructureMPA = exports.createStructureFeature = exports.calculateConvexOfGeometry = exports.createLevelFeature = exports.fixOutlineWithHoles = exports.calculateBbox = exports.calculateReferencePoint = exports.calculateOutlineGeometry = exports.excludeNonPolygonGeometry = exports.fixUnableToCompleteOutputRing = exports.geometryToMultiPolygon = exports.transform = exports.joinTransform = exports.getTransform = exports.filterImlData = exports.alignTopologies = exports.ensureLineStringOrder = exports.skipIdenticalCoordinates = exports.routePointsOfAddress = exports.calculateSide = exports.getLinkTopologies = exports.ensure2dCoordinates = exports.getAddresses = exports.getTopologies = exports.getOutsideRoutePoints = exports.getRoutePoints = exports.getCountry = exports.pointEquals = exports.indoorMapIdRegex = exports.legacyIdRegex = exports.urnRegex = exports.isIdenticalMatrix = exports.formatLogs = void 0;
exports.testExports = exports.getOccupantAttributes = exports.getSpaceGroupsCount = exports.getParkingRestrictionsCount = exports.getspaceCatTypeCount = exports.hasDuplicates = exports.mapSvgFileContents = exports.deepEqualObjects = exports.checkForDuplicateFeatureIds = exports.recalculateSiteAndStructureBoundaries = exports.deleteLevels = exports.getTopologiesForLevel = exports.addLevels = exports.updateLevels = exports.updateLevelSpaces = exports.getFileNameForLevel = exports.isSpaceGeometryChanged = exports.deleteFeatures = exports.removeLevelConnectorReferences = exports.removeOnlyReferences = exports.resizeSpaceSections = exports.updateMPAGeometry = exports.addFeatures = void 0;
exports.info = info;
exports.warning = warning;
exports.error = error;
exports.appendNotes = appendNotes;
exports.setResult = setResult;
const lodash_1 = require("lodash");
const box_intersect_1 = __importDefault(require("box-intersect"));
const line_intersect_1 = __importDefault(require("@turf/line-intersect"));
const point_to_line_distance_1 = __importDefault(require("@turf/point-to-line-distance"));
const nearest_point_on_line_1 = __importDefault(require("@turf/nearest-point-on-line"));
const polygon_to_line_1 = require("@turf/polygon-to-line");
const boolean_intersects_1 = __importDefault(require("@turf/boolean-intersects"));
const centroid_1 = __importDefault(require("@turf/centroid"));
const convex_1 = __importDefault(require("@turf/convex"));
const length_1 = __importDefault(require("@turf/length"));
const along_1 = __importDefault(require("@turf/along"));
const union_1 = __importDefault(require("@turf/union"));
const buffer_1 = __importDefault(require("@turf/buffer"));
const point_on_feature_1 = __importDefault(require("@turf/point-on-feature"));
const center_of_mass_1 = __importDefault(require("@turf/center-of-mass"));
const boolean_point_on_line_1 = __importDefault(require("@turf/boolean-point-on-line"));
const truncate_1 = __importDefault(require("@turf/truncate"));
const meta_1 = require("@turf/meta");
const helpers_1 = require("@turf/helpers");
const tr = __importStar(require("transformation-matrix"));
const boolean_point_in_polygon_1 = __importDefault(require("@turf/boolean-point-in-polygon"));
const bbox_1 = __importDefault(require("@turf/bbox"));
const boolean_contains_1 = __importDefault(require("@turf/boolean-contains"));
const difference_1 = __importDefault(require("@turf/difference"));
const distance_1 = __importDefault(require("@turf/distance"));
const helper_1 = require("../config/helper");
const constants_1 = require("../config/constants");
const geojsonUtils_1 = require("./geojsonUtils");
/** Add an info section to the result */
function info(str, result) {
    if (!result) {
        result = {};
    }
    result.info = result.info || [];
    result.info.push(str);
    return result;
}
/** Add a warning to the result */
function warning(str, result) {
    if (!result) {
        result = {};
    }
    result.warnings = result.warnings || [];
    result.warnings.push(str);
    return result;
}
/** Add an error to the result */
function error(str, result) {
    if (!result) {
        result = {};
    }
    result.errors = result.errors || [];
    result.errors.push(str);
    return result;
}
/** Combine notes from a subresult, with context */
function appendNotes(result, subresult, context) {
    const postfix = context ? ` (${context})` : '';
    const combine = (ready, add) => ([...(ready || []), ...(add || []).map((str) => `${str}${postfix}`)]);
    result.errors = combine(result.errors, subresult.errors);
    result.warnings = combine(result.warnings, subresult.warnings);
}
/** Set final result from another, combining notes */
function setResult(finalResult, result) {
    finalResult.value = result.value;
    appendNotes(finalResult, result);
    return finalResult;
}
const formatLogs = (path, data, logs) => {
    if (data.errors?.length) {
        data.errors.forEach((err) => {
            const msg = err.message ?? err;
            const stack = err.stack ?? err;
            logs.errors?.push({ name: path, message: msg, stack });
        });
    }
    if (data.warnings?.length) {
        data.warnings.forEach((warn) => {
            logs.warnings?.push({ name: path, message: warn });
        });
    }
    if (data.info?.length) {
        data.info.forEach((warn) => {
            logs.info?.push({ name: path, message: warn });
        });
    }
};
exports.formatLogs = formatLogs;
const isIdenticalMatrix = (m1, m2) => (m1.a === m2.a && m1.b === m2.b && m1.c === m2.c && m1.d === m2.d && m1.e === m2.e && m1.f === m2.f);
exports.isIdenticalMatrix = isIdenticalMatrix;
exports.urnRegex = 
// eslint-disable-next-line max-len
/^urn:(here)::here:(indoor.(Structure|Space|Level|Entrance|LevelConnector|SpaceGroups|Site|Occupant)|Topology|Address):\w{8}-[0-9a-fA-F]{12}$/;
exports.legacyIdRegex = /^(space|entrance)-\d{4,12}$/;
exports.indoorMapIdRegex = /^indoormap-[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
/* Compare common number of coordinates of two points, ignore the rest */
const pointEquals = (a, b) => {
    const count = a.length < b.length ? a.length : b.length;
    for (let i = 0; i < count; i += 1) {
        if (a[i] !== b[i]) {
            return false;
        }
    }
    return true;
};
exports.pointEquals = pointEquals;
/* Return the ISO country code of a structure as defined in MOM */
const getCountry = (data) => {
    const structure = data.features.find((feature) => feature.momType === 'indoor.Structure');
    if (!structure) {
        return undefined;
    }
    const { isoCountryCode } = structure.properties;
    return isoCountryCode;
};
exports.getCountry = getCountry;
/* Return all route points defined in an indoor map */
const getRoutePoints = (indoorMap) => {
    const addresses = indoorMap.features
        .filter((feature) => feature.momType === 'Address' &&
        feature.properties.category === 'MicroPA' &&
        feature.properties.routingPoints);
    return addresses
        .map((address) => address.properties.routingPoints ?? []).flat();
};
exports.getRoutePoints = getRoutePoints;
/* Return all route points of an indoor map which refer to an outdoor road */
const getOutsideRoutePoints = (indoorMap) => (0, exports.getRoutePoints)(indoorMap)
    .filter((point) => point.roadId.match(/^[0-9]+/));
exports.getOutsideRoutePoints = getOutsideRoutePoints;
/* Return all topology features in an indoor map */
const getTopologies = (indoorMap) => indoorMap.features
    .filter((feature) => feature.momType === 'Topology');
exports.getTopologies = getTopologies;
/* Return all address features in an indoor map */
const getAddresses = (indoorMap) => indoorMap.features
    .filter((feature) => feature.momType === 'Address');
exports.getAddresses = getAddresses;
/* Remove the Z coordinate from all features */
const ensure2dCoordinates = (features) => {
    const stripCoordinates = (coordinates) => {
        if (!coordinates || coordinates.length === 0) {
            return;
        }
        if (Array.isArray(coordinates[0])) {
            coordinates.forEach(stripCoordinates);
            return;
        }
        coordinates.splice(2);
    };
    features.forEach((feature) => stripCoordinates(feature.geometry.coordinates));
};
exports.ensure2dCoordinates = ensure2dCoordinates;
/* Return all topologies which are connected to the given list of route points. This is usually
 * used to identify the topologies which link to the outdoor map
 */
const getLinkTopologies = (routePoints, indoorMap) => (0, exports.getTopologies)(indoorMap)
    .filter((topology) => {
    const startNodePosition = topology.geometry.coordinates[0];
    const endNodePosition = topology.geometry.coordinates[topology.geometry.coordinates.length - 1];
    return routePoints.find((routePoint) => (0, exports.pointEquals)(routePoint.point.coordinates, startNodePosition) ||
        (0, exports.pointEquals)(routePoint.point.coordinates, endNodePosition)) !== undefined;
});
exports.getLinkTopologies = getLinkTopologies;
/* Return the side of a topology a point is located. Calculate the side via cross product between the topology vector
 * and a vector to the target point. If the product is positive, the point is on the left side, if negative, it is on
 * the right side. If if is zero, the point is on the line. The positions are scaled before calculation to avoid too
 * small values to be used. The topology vector is always from the start node to the end node.
 */
const calculateSide = (topology, point) => {
    const topologyStart = topology.geometry.coordinates[0];
    const topologyEnd = topology.geometry.coordinates[topology.geometry.coordinates.length - 1];
    const scale = 1000000;
    const Ax = topologyEnd[0] * scale - topologyStart[0] * scale;
    const Ay = topologyEnd[1] * scale - topologyStart[1] * scale;
    const Bx = point[0] * scale - topologyStart[0] * scale;
    const By = point[1] * scale - topologyStart[1] * scale;
    const angle = Ax * By - Ay * Bx;
    if (angle > 0) {
        return 'LEFT';
    }
    if (angle < 0) {
        return 'RIGHT';
    }
    return 'BOTH';
};
exports.calculateSide = calculateSide;
const routePointsOfAddress = (address) => {
    if (address.properties.category === 'MicroPA') {
        return address.properties.routingPoints || [];
    }
    return address.properties.routePoint ? [address.properties.routePoint] : [];
};
exports.routePointsOfAddress = routePointsOfAddress;
const skipIdenticalCoordinates = (lineString, linePoint) => {
    if (lineString.length > 0 && (0, exports.pointEquals)(lineString[lineString.length - 1], linePoint)) {
        return lineString;
    }
    return [...lineString, linePoint];
};
exports.skipIdenticalCoordinates = skipIdenticalCoordinates;
const ensureLineStringOrder = (lineString) => {
    if (lineString.length > 1) {
        return lineString;
    }
    if (lineString.length === 1) {
        lineString.push([lineString[0][0], lineString[0][1] + 0.00000001]);
        return lineString;
    }
    throw new Error('LineString with zero nodes');
};
exports.ensureLineStringOrder = ensureLineStringOrder;
/* Ensure start nodes are southernmost nodes in a topology: If needed, reverse the topology and
 * swap access characteristics. If start and end node are on the same latitude, ensure the start node is the
 * westernmost node. Update the sides of all addresses' route points.
 */
const alignTopologies = async (indoorMap) => {
    /* eslint-disable no-param-reassign */
    const results = [];
    const topologies = (0, exports.getTopologies)(indoorMap);
    topologies.forEach((t) => {
        const startNode = t.geometry.coordinates[0];
        const endNode = t.geometry.coordinates[t.geometry.coordinates.length - 1];
        if (startNode[1] > endNode[1] ||
            (startNode[1] === endNode[1] && startNode[0] > endNode[0])) {
            const { startNodeId } = t.properties;
            t.properties.startNodeId = t.properties.endNodeId;
            t.properties.endNodeId = startNodeId;
            t.geometry.coordinates.reverse();
            results.push(`Reverted topology=${t.id}`);
            if (!t.properties.accessCharacteristics) {
                return;
            }
            t.properties.accessCharacteristics.forEach((characteristic) => {
                if (characteristic.appliesTo === 'FROM_START') {
                    characteristic.appliesTo = 'TO_START';
                    return;
                }
                if (characteristic.appliesTo === 'TO_START') {
                    characteristic.appliesTo = 'FROM_START';
                }
            });
        }
    });
    (0, exports.getAddresses)(indoorMap).forEach((address) => {
        (0, exports.routePointsOfAddress)(address).forEach((routePoint) => {
            const topology = topologies.find((t) => t.id === routePoint.roadId);
            if (topology) {
                const currentSide = routePoint.side;
                routePoint.side = (0, exports.calculateSide)(topology, (0, centroid_1.default)(address.geometry).geometry.coordinates);
                if (routePoint.side !== currentSide) {
                    results.push(`Updated side address=${address.id}`);
                }
            }
        });
    });
    /* eslint-enable no-param-reassign */
    return results;
};
exports.alignTopologies = alignTopologies;
/* Remove properties which are used only internally and should not be part of released data */
const filterImlData = (indoorMap) => {
    indoorMap.features.forEach((feature) => {
        /* eslint-disable no-param-reassign */
        if (feature.properties['@ns:com:here:xyz']) {
            delete feature.properties['@ns:com:here:xyz'];
        }
        if (feature.properties['@ns:com:here:mom:delta']) {
            delete feature.properties['@ns:com:here:mom:delta'];
        }
        if (feature.properties['@ns:com:here:mom:mapcreator']) {
            delete feature.properties['@ns:com:here:mom:mapcreator'];
        }
        if (feature.properties['@ns:com:here:mom:rmob']) {
            delete feature.properties['@ns:com:here:mom:rmob'];
        }
        if (feature.properties['@ns:com:here:groundTruth']) {
            delete feature.properties['@ns:com:here:groundTruth'];
        }
        // Clear user id from the metadata
        if (feature.properties['@ns:com:here:mom:meta'] && feature.properties['@ns:com:here:mom:meta'].lastUpdatedBy) {
            feature.properties['@ns:com:here:mom:meta'].lastUpdatedBy = null;
        }
        /* eslint-enable no-param-reassign */
    });
};
exports.filterImlData = filterImlData;
/**
 * Find largest triangle of non-zero-size out of positions. Return index references or undefined
 * if no such triangle found.
 */
const getLargestTriangle = (allPositions) => {
    const hull = (0, convex_1.default)({ type: 'MultiPoint', coordinates: allPositions });
    if (!hull) {
        return undefined;
    }
    const positions = hull.geometry.coordinates[0];
    const area = (...[i1, i2, i3]) => {
        const [[x1, y1], [x2, y2], [x3, y3]] = [positions[i1], positions[i2], positions[i3]];
        return Math.abs(x1 * (y2 - y3) + x2 * (y3 - y1) + x3 * (y1 - y2)) / 2;
    };
    const inc = (index) => (index + 1) % positions.length;
    // Algorithm proof in https://ieeexplore.ieee.org/document/4567996, general description also here in
    // https://www.sciencedirect.com/science/article/abs/pii/S0020019020300302
    // (preview at https://arxiv.org/abs/1705.11035)
    let best = {
        size: 0, pos1: 0, pos2: 0, pos3: 0,
    };
    for (let pos1 = 0; pos1 < positions.length; pos1 += 1) {
        let pos2 = inc(pos1);
        let pos3 = inc(pos2);
        let size = 0;
        while (pos2 !== pos1) {
            while (pos3 !== pos1) {
                const newSize = area(pos1, pos2, inc(pos3));
                if (newSize < size) {
                    break;
                }
                size = newSize;
                pos3 = inc(pos3);
            }
            const newSize = area(pos1, inc(pos2), pos3);
            if (newSize < size) {
                break;
            }
            size = newSize;
            pos2 = inc(pos2);
        }
        if (size >= best.size) {
            best = {
                size, pos1, pos2, pos3,
            };
        }
    }
    if (best.size === 0) {
        return undefined;
    }
    const findOriginal = (posIndex) => allPositions.findIndex((origPos) => (0, exports.pointEquals)(positions[posIndex], origPos));
    const result = [best.pos1, best.pos2, best.pos3].map(findOriginal);
    return result;
};
/**
 * Get coordinate transform matrix needed to transform original geometry to changed, or undefined if
 * geometries cannot be used.
 */
const getTransform = (original, changed) => {
    const originalFlat = (0, meta_1.coordAll)(original);
    const changedFlat = (0, meta_1.coordAll)(changed);
    const triangle = getLargestTriangle(originalFlat);
    let result;
    if (triangle && originalFlat.length === changedFlat.length) {
        const t1 = triangle.map((i) => originalFlat[i]);
        const t2 = triangle.map((i) => changedFlat[i]);
        try {
            result = tr.fromTriangles(t1, t2);
        }
        catch {
            // eslint-disable no-empty
        }
    }
    return tr.isAffineMatrix(result ?? {}) ? result : undefined;
};
exports.getTransform = getTransform;
/** Combine tranformation matrices */
const joinTransform = (...matrices) => tr.compose(...matrices);
exports.joinTransform = joinTransform;
/**
* Transform all coordinates of featureCollection. Any feature bboxes are removed (i.e. not recalculated).
* @param featureCollection - Mom feature collection
* @param change - TransformationMatrix
* returns void
*/
const transform = (featureCollection, change) => {
    const walk = (data) => {
        if (data?.coordinates) {
            // console.log({ data: JSON.stringify(data) });
            (0, meta_1.coordEach)(data, (point) => {
                // eslint-disable-next-line no-param-reassign
                [point[0], point[1]] = tr.applyToPoint(change, point).map((num) => parseFloat(num.toFixed(13)));
            });
        }
        else if (typeof data === 'object') {
            Object.values(data).forEach(walk);
        }
    };
    walk(featureCollection);
    for (const feature of featureCollection.features) {
        // Level has special format for elevationPoints
        if (feature.momType === 'indoor.Level') {
            for (const { point } of (feature.properties.elevationPoints || [])) {
                [point[0], point[1]] = tr.applyToPoint(change, point);
            }
        }
        if (['indoor.Space', 'indoor.Entrance'].includes(feature.momType)) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            feature.referencePoint = (0, exports.calculateReferencePoint)(feature.geometry);
        }
        delete feature.bbox;
    }
};
exports.transform = transform;
/**
 * to convert polygon to multipolygon
 * @param polygon - geometry of polygon
 * @returns multipolygon geometry
 */
const geometryToMultiPolygon = (geometry) => {
    const multiPolygon = {
        type: 'MultiPolygon',
        coordinates: [],
    };
    switch (geometry?.type) {
        case 'MultiPolygon':
            multiPolygon.coordinates = multiPolygon.coordinates.concat(geometry.coordinates);
            break;
        case 'Polygon':
            multiPolygon.coordinates = multiPolygon.coordinates.concat([geometry.coordinates]);
            break;
        case 'LineString':
            multiPolygon.coordinates = multiPolygon.coordinates.concat([[geometry.coordinates]]);
            break;
        case 'Point':
            multiPolygon.coordinates = multiPolygon.coordinates.concat([[[geometry.coordinates]]]);
            break;
        default:
            break;
    }
    return multiPolygon;
};
exports.geometryToMultiPolygon = geometryToMultiPolygon;
/**
 *
 * @param feature1  - Geometry with coordinates error
 * @param feature2  - Geometry with possible coordinates error
 * @returns - Fixed geometry object
 */
const fixUnableToCompleteOutputRing = (feature1, feature2) => {
    let fixedGeometry = null;
    try {
        fixedGeometry = (0, buffer_1.default)(feature1, 0.000001); // default unit for buffer is in kilometers
        fixedGeometry = (0, union_1.default)(fixedGeometry, feature2);
    }
    catch (ex) {
        // This happens if we have two polygons that interweaves together too closely
        // Applying a small buffer usually corrects it
        if (ex instanceof Error &&
            /Unable to complete output ring|Maximum call stack size exceeded|Unable to find segment/g.test(ex.message)) {
            (0, exports.fixUnableToCompleteOutputRing)(fixedGeometry, feature2);
        }
    }
    return fixedGeometry;
};
exports.fixUnableToCompleteOutputRing = fixUnableToCompleteOutputRing;
/**
 * to remove unwanted linestrings/points from outline geometry calculation
 * @param geometryFeature - a multipolygon geometry feature (outline geometry)
 * updates the existing multipolygon geometry
 */
const excludeNonPolygonGeometry = (geometryFeature) => {
    const correctedCoordinates = geometryFeature.coordinates
        .map((coordinate) => (0, lodash_1.filter)(coordinate, (coord) => coord.length >= 4)).filter((coord) => !(0, lodash_1.isEmpty)(coord));
    geometryFeature.coordinates = correctedCoordinates;
};
exports.excludeNonPolygonGeometry = excludeNonPolygonGeometry;
/**
 * to calculate the outline of a level from space geometries
 * @param features - Feature array of spaces extracted from svgs
 * @returns multiPolygon outline geometry of level
 */
const calculateOutlineGeometry = (features) => {
    if (!features || !Array.isArray(features) || features.length === 0)
        throw new Error('Features not found');
    const polygonGeometries = features?.filter((feature) => feature.geometry.type === 'MultiPolygon' ||
        feature.geometry.type === 'Polygon');
    let levelOutline = polygonGeometries[0];
    if (polygonGeometries.length === 0)
        throw new Error('Features not found');
    else if (polygonGeometries.length === 1) {
        if (levelOutline.geometry.type === 'Polygon') {
            return (0, exports.geometryToMultiPolygon)(levelOutline.geometry);
        }
        return levelOutline.geometry;
    }
    for (let i = 1; i < polygonGeometries.length; i += 1) {
        try {
            levelOutline = (0, union_1.default)(levelOutline.geometry, polygonGeometries[i].geometry);
        }
        catch (err) {
            levelOutline = (0, exports.fixUnableToCompleteOutputRing)(levelOutline.geometry, polygonGeometries[i].geometry);
        }
    }
    if (levelOutline.geometry.type === 'Polygon') {
        const multiPolygonGeometry = (0, exports.geometryToMultiPolygon)(levelOutline.geometry);
        (0, exports.excludeNonPolygonGeometry)(multiPolygonGeometry);
        return multiPolygonGeometry;
    }
    (0, exports.excludeNonPolygonGeometry)(levelOutline.geometry);
    return levelOutline.geometry;
};
exports.calculateOutlineGeometry = calculateOutlineGeometry;
/**
 * to calculate the reference point of geometry
 * @param geometry - geometry of a feature to calculate reference coordinates
 * @returns centroid coordinates of the feature
 */
const calculateReferencePoint = (geometry) => {
    let featureCentroid = (0, center_of_mass_1.default)(geometry);
    switch (geometry.type) {
        case 'Point':
            featureCentroid.geometry = geometry;
            break;
        case 'LineString':
            if (!(0, boolean_point_on_line_1.default)((0, centroid_1.default)(geometry), geometry)) {
                const lineLength = (0, length_1.default)({ type: 'Feature', geometry, properties: {} }, { units: 'centimeters' });
                featureCentroid = (0, along_1.default)(geometry, lineLength / 2, { units: 'centimeters' });
            }
            break;
        case 'MultiPolygon':
        case 'Polygon':
            if (!(0, boolean_point_in_polygon_1.default)(featureCentroid, geometry)) {
                featureCentroid = (0, point_on_feature_1.default)(geometry);
            }
            break;
        default:
            featureCentroid = (0, center_of_mass_1.default)(geometry);
            break;
    }
    const options = { precision: 7 };
    const truncatedGeometry = (0, truncate_1.default)(featureCentroid.geometry, options);
    return truncatedGeometry;
};
exports.calculateReferencePoint = calculateReferencePoint;
/**
 * to calculate the bbox of geometry
 * @param geometry - any type of geometry
 * @returns bbox calculated for the given geometry
 */
const calculateBbox = (geometry) => {
    const bboxGeometry = (0, bbox_1.default)(geometry).map((geo) => Number(geo.toFixed(7)));
    return bboxGeometry;
};
exports.calculateBbox = calculateBbox;
/**
 * It will fix the outline with holes in it
 * @param outline - Outline which may/may not contains holes
 * @returns Outline with holes subtracted from the outer polygon is exists
 */
const fixOutlineWithHoles = (outline) => {
    // This will only run if the MultiPolygon geometry has actual multiple polygons in it.
    // That means there are a chances of having a hole inside outer polygon
    if (outline.coordinates.length > 1) {
        const polygonArray = [];
        outline.coordinates.forEach((coord) => {
            polygonArray.push({ type: 'Feature', geometry: { type: 'Polygon', coordinates: coord }, properties: {} });
        });
        const newPolygonArray = [];
        let k = 0;
        let holeFound = false;
        // This is to check if the polygon is either outer or inner(hole)
        // i.e. it will be set as true if polygon is one of the mentioned. If polygon is just a standalone outline, then it will remain as false
        const polygonConsidered = [];
        for (let i = 0; i < polygonArray.length; i += 1) {
            holeFound = false;
            for (let j = 0; j < polygonArray.length; j += 1) {
                if (i !== j && (0, boolean_contains_1.default)(polygonArray[i], polygonArray[j])) {
                    // There are chances of having multiple holes in a single outline
                    newPolygonArray[k] = newPolygonArray[k] ? (0, difference_1.default)(newPolygonArray[k], polygonArray[j])
                        : (0, difference_1.default)(polygonArray[i], polygonArray[j]);
                    // To handle worst case scenario where two geometries overlap on each other and their difference is null
                    if (!newPolygonArray[k]) {
                        newPolygonArray[k] = polygonArray[i];
                    }
                    polygonConsidered[i] = true;
                    polygonConsidered[j] = true;
                    holeFound = true;
                }
            }
            if (holeFound) {
                k += 1;
            }
        }
        for (let l = 0; l < polygonArray.length; l += 1) {
            if (!polygonConsidered[l]) {
                // This will add the standalone polygons in the new array
                newPolygonArray.push(polygonArray[l]);
            }
        }
        const newOutlineCoords = [];
        for (let c = 0; c < newPolygonArray.length; c += 1) {
            newOutlineCoords[c] = newPolygonArray[c].geometry.coordinates;
        }
        if (newOutlineCoords.length > 0) {
            outline.coordinates = newOutlineCoords;
        }
    }
    return outline;
};
exports.fixOutlineWithHoles = fixOutlineWithHoles;
/**
 * to generate the level feature object
 * @param levelId - String id of the level (UUID)
 * @param features - Array of feature objects
 * @param levelProperties - Adhoc properties which needs to included for the creation of the momJSON object for level
 */
const createLevelFeature = (levelId, features, levelProperties) => {
    if (!levelId || !levelProperties)
        throw new Error(`Level Properties are missing for level: ${levelId}`);
    if (!features || !Array.isArray(features) || features.length === 0)
        throw new Error(`Features not found for level ${levelId}`);
    const levelOutlineInitial = (0, exports.calculateOutlineGeometry)(features);
    const levelOutline = (0, exports.fixOutlineWithHoles)(levelOutlineInitial);
    const bboxValue = (0, exports.calculateBbox)(levelOutline);
    const referencePointValue = (0, exports.calculateReferencePoint)(levelOutline);
    const levelFeature = {
        type: 'Feature',
        id: levelId,
        momType: 'indoor.Level',
        geometry: levelOutline,
        // location,
        properties: levelProperties,
        bbox: bboxValue,
        referencePoint: referencePointValue,
    };
    return levelFeature;
};
exports.createLevelFeature = createLevelFeature;
const calculateConvexOfGeometry = (features) => {
    const convexOfGeometry = (0, convex_1.default)(features);
    return convexOfGeometry;
};
exports.calculateConvexOfGeometry = calculateConvexOfGeometry;
/**
 * to generate the structure feature object
 * @param structureId - String id of the structure (UUID)
 * @param features - Array of feature objects
 * @param structureProperties - Adhoc properties which needs to included for the creation of the momJSON object for structure
 */
const createStructureFeature = (structureId, features, structureProperties) => {
    if (!features || !Array.isArray(features) || features.length === 0)
        throw new Error('Features not found');
    if (!structureId)
        throw new Error('Structure id missing');
    const structureOutline = (0, exports.calculateOutlineGeometry)(features);
    const referencePointValue = (0, exports.calculateReferencePoint)(structureOutline);
    const structureFeature = {
        type: 'Feature',
        id: structureId,
        momType: 'indoor.Structure',
        geometry: structureOutline,
        // location,
        properties: structureProperties,
        referencePoint: referencePointValue,
    };
    return structureFeature;
};
exports.createStructureFeature = createStructureFeature;
const createStructureMPA = (structure, siteProperties) => {
    if (!structure.id)
        throw new Error('Structure id missing');
    const structureAddressFeature = {
        type: 'Feature',
        id: `urn:here::here:Address:STR${structure.id.slice(structure.id.indexOf('Structure') + 13)}`,
        momType: 'Address',
        geometry: structure.referencePoint,
        properties: {
            category: 'MicroPA',
            featureType: 'Address',
            parentPointAddressId: {
                id: siteProperties.address.streetAddressExternal?.id || 'not_available',
            },
            defaultDisplayPointType: 'INDOOR_SPACE_CENTROID',
        },
        referencePoint: structure.referencePoint,
    };
    return structureAddressFeature;
};
exports.createStructureMPA = createStructureMPA;
/**
 * to generate the site feature object
 * @param siteId - String id of the site (UUID)
 * @param features - Array of feature objects
 * @param siteProperties - Adhoc properties which needs to included for the creation of the momJSON object for site
 */
const createSiteFeature = (siteId, features, siteProperties) => {
    if (!features || !Array.isArray(features) || features.length === 0)
        throw new Error('Features not found');
    if (!siteId)
        throw new Error('Site id missing');
    const siteOutline = (0, exports.calculateConvexOfGeometry)({ type: 'FeatureCollection', features });
    const finalSiteOutline = (0, exports.geometryToMultiPolygon)(siteOutline.geometry);
    const referencePointValue = (0, exports.calculateReferencePoint)(finalSiteOutline);
    const siteFeature = {
        type: 'Feature',
        id: siteId,
        momType: 'indoor.Site',
        geometry: finalSiteOutline,
        // location,
        properties: siteProperties,
        referencePoint: referencePointValue,
    };
    return siteFeature;
};
exports.createSiteFeature = createSiteFeature;
/**
 * Simplifies space rules which data can be directly used in the MOM conversion based on colorCode
 * @param spaceRules input from base colorRules
 * @returns SimplifiedSpaceRules
 */
const simplifySpaceRules = (spaceRules) => {
    const simplifiedRules = {};
    const allSpaceCategories = Object.keys(spaceRules);
    for (let i = 0; i < allSpaceCategories.length; i += 1) {
        const allSpaceTypes = Object.keys(spaceRules[allSpaceCategories[i]]);
        for (let j = 0; j < allSpaceTypes.length; j += 1) {
            for (let k = 0; k < spaceRules[allSpaceCategories[i]][allSpaceTypes[j]].length; k += 1) {
                const spaceProperties = spaceRules[allSpaceCategories[i]][allSpaceTypes[j]][k];
                const mainSpaceProperties = {
                    spaceCategory: allSpaceCategories[i],
                    spaceType: allSpaceTypes[j],
                };
                const finalSpaceProperties = { ...mainSpaceProperties, ...spaceProperties };
                simplifiedRules[spaceProperties.colorCode] = finalSpaceProperties;
                delete simplifiedRules[spaceProperties.colorCode].colorCode;
            }
        }
    }
    return simplifiedRules;
};
exports.simplifySpaceRules = simplifySpaceRules;
/**
 * Simplifies entrance rules which data can be directly used in the MOM conversion based on colorCode
 * @param entranceRules input from base colorRules
 * @returns SimplifiedEntranceRules
 */
const simplifyEntranceRules = (entranceRules) => {
    const simplifiedRules = {};
    const allEntranceTypes = Object.keys(entranceRules);
    for (let c = 0; c < allEntranceTypes.length; c += 1) {
        const entranceProperties = {
            type: allEntranceTypes[c],
            names: [],
            objectType: entranceRules[allEntranceTypes[c]].objectType,
        };
        simplifiedRules[entranceRules[allEntranceTypes[c]].colorCode] = entranceProperties;
    }
    return simplifiedRules;
};
exports.simplifyEntranceRules = simplifyEntranceRules;
/**
 * Creates Space feature object of Indoor MOM data
 * @param geometries Geometry of feature
 * @param colorCode colorCode received in SVG element
 * @param spaceRules SimplifiedSpaceRules
 * @param featureProperties pre-requisite feature properties
 * @param id feature Id
 * @returns Indoor MOM Space feature
 */
const createSpaceFeature = (geometry, colorCode, spaceRules, featureProperties, id) => {
    if (geometry.type === 'MultiPolygon') {
        geometry = (0, exports.fixOutlineWithHoles)(geometry);
    }
    const feature = {
        type: 'Feature',
        id,
        momType: 'indoor.Space',
        geometry,
        properties: {
            ...featureProperties, ...spaceRules[colorCode],
        },
    };
    delete feature.properties?.objectType;
    return feature;
};
exports.createSpaceFeature = createSpaceFeature;
/**
 * Creates Entrance feature object of Indoor MOM data
 * @param geometry Geometry of feature
 * @param colorCode colorCode received in SVG element
 * @param entranceRules SimplifiedEntranceRules
 * @param featureProperties pre-requisite feature properties
 * @param id feature Id
 * @returns Indoor MOM Entrance feature
 */
const createEntranceFeature = (geometry, colorCode, entranceRules, featureProperties, id) => {
    const feature = {
        type: 'Feature',
        id,
        momType: 'indoor.Entrance',
        geometry,
        properties: {
            ...featureProperties, ...entranceRules[colorCode],
        },
    };
    delete feature.properties?.objectType;
    return feature;
};
exports.createEntranceFeature = createEntranceFeature;
/**
 * Calculates stack indices for every space based on overlapping and intersections
 * @param spaces All the space features in the level
 */
const updateStackIndex = (spaces) => {
    // sort by drawOrder first to correctly assign stackIndex
    spaces.sort((a, b) => a.properties.drawOrder - b.properties.drawOrder);
    // Create bounding boxes in metric domain for the spaces, with coordinates as zero based integers
    const [spaceLonMin, spaceLatMin] = (0, bbox_1.default)({
        type: 'FeatureCollection',
        features: spaces,
    });
    const gridSpacing = 1.0;
    const latGridStep = (0, helpers_1.lengthToDegrees)(gridSpacing, 'meters');
    const lonGridStep = latGridStep * ((90 - Math.abs(spaceLatMin)) / 90);
    const boundingBoxes = spaces.map((space) => {
        const [lonMin, latMin, lonMax, latMax] = (0, bbox_1.default)(space);
        const box = [
            Math.floor((lonMin - spaceLonMin) / lonGridStep), // minX
            Math.floor((latMin - spaceLatMin) / latGridStep), // minY
            Math.ceil((lonMax - spaceLonMin) / lonGridStep), // maxX
            Math.ceil((latMax - spaceLatMin) / latGridStep), // maxY
        ];
        return box;
    });
    // 1. Broad phase: get possible intersects with boxIntersect (results is an array of pairs as indexes to input)
    // 2. Make larger drawOrder of the intersect spaces as first in the pair (for possible linestring intersect
    //    comparison and following overlap calcuation)
    // 3. Narrow phase: filter true intersects by using exact geometry calculation
    const intersections = (0, box_intersect_1.default)(boundingBoxes)
        .map(([i, j]) => (i > j ? [i, j] : [j, i]))
        .filter(([i, j]) => {
        let intersect = false;
        const geometry1 = spaces[i].geometry;
        const geometry2 = spaces[j].geometry;
        // Note: Ideally just checking one space is completely occupied by other place is fine,
        // but if the edge of the polygon is exactly on the edge of another polygon, it is not considered as "within"
        // that is why we are using '@turf/boolean-intersect' package and not '@turf/boolean-contains' or '@turf/boolean-within'
        // However comparing lines with booleanIntersects fails quite often, as coordinates are never accurate enough.
        // Using alternative method for line-to-line comparison
        if (geometry1.type === 'LineString' && geometry2.type === 'LineString') {
            // as seen elsewhere in this class, MultiLineStrings are not supported; Micello doesn't produce them
            const linesOverlap = (point, line) => {
                const d = (0, point_to_line_distance_1.default)(point, line, { units: 'kilometers' });
                return (d < 0.00005); // 5cm
            };
            intersect = geometry1.coordinates.some((coord) => linesOverlap(coord, geometry2));
        }
        else {
            // the normal case; typically a polygon involved
            intersect = (0, boolean_intersects_1.default)(geometry1, geometry2);
        }
        return intersect;
    });
    // Get overlaps, where key is an index to space and value is array of index pairs (the other space of each
    // pair has lower drawing order than the key)
    const overlaps = (0, lodash_1.groupBy)(intersections, ([i, _j]) => i);
    // Set stack index in the increasing drawing order, to one larger than any overlapped ones (minimum is 1)
    spaces.forEach((space, i) => {
        space.properties.stackIndex = (overlaps[i] || [])
            .reduce((current, [_i, j]) => Math.max(current, spaces[j].properties.stackIndex), 0) + 1;
    });
};
exports.updateStackIndex = updateStackIndex;
/**
 * This will find a point exactly on or little inside of a given levelGeometry by using buffer value
 * @param point
 * @param levelGeometry
 * @param bufferValue
 * @returns point on or inside levelGeometry
 */
const getPointOnLine = (point, levelGeometry, bufferValue) => {
    let pointOnLine = (0, lodash_1.cloneDeep)(point);
    let pointFound = false;
    const possiblePointsInPolygon = (0, geojsonUtils_1.getFourCoordinatesFromPoint)(point, bufferValue);
    for (let j = 0; j < 4; j += 1) {
        if ((0, boolean_point_in_polygon_1.default)(possiblePointsInPolygon[j], levelGeometry)) {
            pointOnLine = possiblePointsInPolygon[j];
            pointFound = true;
            break;
        }
    }
    if (!pointFound) {
        bufferValue += 0.0000001;
        return (0, exports.getPointOnLine)((0, lodash_1.cloneDeep)(point), levelGeometry, bufferValue);
    }
    return pointOnLine;
};
exports.getPointOnLine = getPointOnLine;
/**
 * Updates the entrance/exit icon position on or nearest to level outline or doors
 * @param entrances All the entrances present on the level
 * @param levelOutline
 * @param doors All the doors present on the level
 */
const updateEntrancePosition = (entrances, levelOutline, levelGeometry, doors) => {
    entrances.forEach((entrance) => {
        let pointOnLine = { type: 'Point', coordinates: levelOutline[0][0] }; // default value
        let isValidIcon = false;
        let intersectingFeatures;
        // Push all the doors also inside levelOutline array
        doors?.forEach((door) => levelOutline.push(door.geometry.coordinates));
        for (let i = 0; i < levelOutline.length; i += 1) {
            const entryExitLine = { type: 'LineString', coordinates: levelOutline[i] };
            // Check for the intersection with level outline or doors
            intersectingFeatures = (0, line_intersect_1.default)(entrance.geometry, entryExitLine);
            if (intersectingFeatures.features.length > 0) {
                isValidIcon = true;
                pointOnLine = (0, nearest_point_on_line_1.default)(entryExitLine, (0, centroid_1.default)(entrance.geometry)).geometry;
                // If the point doesn't fall on or inside levelGeometry, find another point with some buffer added
                if (!(0, boolean_point_in_polygon_1.default)(pointOnLine, levelGeometry)) {
                    pointOnLine = (0, exports.getPointOnLine)(pointOnLine, levelGeometry, 0.0000001);
                }
                break;
            }
        }
        // If entrance/exit icon is not intersecting, throw error
        if (!isValidIcon) {
            throw Error('Entrance/Exit icon is not intersecting with level outline or any of the doors');
        }
        entrance.geometry = pointOnLine;
        entrance.referencePoint = entrance.geometry;
    });
};
exports.updateEntrancePosition = updateEntrancePosition;
const createLevelGeometry = (geometry) => {
    const feature = {
        type: 'Feature',
        momType: 'LevelGeometry',
        geometry,
    };
    return feature;
};
exports.createLevelGeometry = createLevelGeometry;
/**
 * Creates new feature id based on featureType
 * @param featureType Feature Type
 * @param indoorMapId Indoor map id
 * @param featureNumber Number with which you want to create featureId
 * @returns featureId
 */
const getNewFeatureId = (featureType, indoorMapId, featureNumber) => {
    const id = `urn:here::here:${featureType}:${featureNumber.padStart(8, '0')}-${indoorMapId.slice(-12)}`;
    if (!exports.urnRegex.test(id)) {
        throw Error(`Invalid id generated ${id}`);
    }
    return id;
};
exports.getNewFeatureId = getNewFeatureId;
const getOutlineAsLine = (levelGeometry) => {
    const outlineAsAnyLine = (0, polygon_to_line_1.multiPolygonToLine)(levelGeometry);
    let outlineAsLine = [];
    // if site is a real MultiPolygon, the outlineAsAnyLine seems to be a set of features,
    // otherwise (only 1 polygon wrapped to MultiPolygon) it is a LineString feature
    if (outlineAsAnyLine.features.some((feature) => feature.geometry.type !== 'LineString')) {
        // if the result is a set of multilinestrings, it is expected to represent polygon with holes, i.e. a level with inner courtyard(s)
        (0, helper_1.logMsg)('Level outline consists of MultiLineStrings');
    }
    outlineAsAnyLine.features.forEach((f) => {
        if (f.geometry.type === 'MultiLineString') {
            // Take all interior & exterior rings
            outlineAsLine = [...outlineAsLine, ...f.geometry.coordinates.map((lineRing) => lineRing)];
        }
        else {
            // Only exterior ring exists, take it
            outlineAsLine = [...outlineAsLine, f.geometry.coordinates];
        }
    });
    return outlineAsLine;
};
exports.getOutlineAsLine = getOutlineAsLine;
const getLevelFeaturesByLevelId = (mom, levelId) => {
    const levelFeatureObject = (0, lodash_1.find)(mom.features, { id: levelId, momType: 'indoor.Level' });
    if (!levelFeatureObject) {
        throw Error(`Invalid LevelId : "${levelId}"`);
    }
    const levelFeatures = (0, lodash_1.filter)(mom.features, { properties: { level: { id: levelId } } });
    if (levelFeatures.length === 0) {
        throw Error(`There are no valid features in the level : "${levelId}"`);
    }
    return [levelFeatureObject, ...levelFeatures];
};
exports.getLevelFeaturesByLevelId = getLevelFeaturesByLevelId;
/**
 * To add user information to the feature object
 * such as create/delete/update
 * @param properties - MOM feature property which needs to be updated
 * @param metadata - User metadata
 * @param newProperties - Modified mom property to be updated
 */
const patchMeta = (properties, metadata, newProperties) => {
    /* To handle scenarios where existing metadata needs to be
     updated in the new feature properties, added an optional newProperties field */
    if (newProperties) {
        if (!properties['@ns:com:here:mom:meta']) {
            newProperties['@ns:com:here:mom:meta'] = {
                modelVersion: metadata.modelVersion,
                lastUpdatedBy: metadata.lastUpdatedBy,
            };
        }
        else if (properties['@ns:com:here:mom:meta'] && properties['@ns:com:here:mom:meta'].lastUpdatedBy &&
            !properties['@ns:com:here:mom:meta'].lastUpdatedBy.includes(metadata.lastUpdatedBy)) {
            const existingUser = properties['@ns:com:here:mom:meta'].lastUpdatedBy;
            newProperties['@ns:com:here:mom:meta'] = {
                modelVersion: metadata.modelVersion,
                lastUpdatedBy: `${existingUser},${metadata.lastUpdatedBy}`,
            };
        }
    }
    else if (!properties['@ns:com:here:mom:meta']) {
        properties['@ns:com:here:mom:meta'] = {
            modelVersion: metadata.modelVersion,
            lastUpdatedBy: metadata.lastUpdatedBy,
        };
    }
    else if (properties['@ns:com:here:mom:meta'] && properties['@ns:com:here:mom:meta'].lastUpdatedBy &&
        !properties['@ns:com:here:mom:meta'].lastUpdatedBy.includes(metadata.lastUpdatedBy)) {
        const existingUser = properties['@ns:com:here:mom:meta']?.lastUpdatedBy;
        properties['@ns:com:here:mom:meta'] = {
            modelVersion: metadata.modelVersion,
            lastUpdatedBy: `${existingUser},${metadata.lastUpdatedBy}`,
        };
    }
};
exports.patchMeta = patchMeta;
/**
 * To modify the state of the feature object based the functionality performed by the user
 * such as create/delete/update
 * @param properties - MOM feature property which needs to be updated
 * @param state - state of the feature object
 */
const patchDelta = (properties, state) => {
    // console.log("metadata: patchDelta", metadata, properties)
    properties['@ns:com:here:mom:delta'] = {
        changeState: state,
        reviewState: 'UNPUBLISHED',
    };
};
exports.patchDelta = patchDelta;
/**
 * @param properties
 * @returns changeState of the given feature properties
 */
const getDeltaChangeState = (properties) => properties['@ns:com:here:mom:delta']?.changeState;
exports.getDeltaChangeState = getDeltaChangeState;
/**
 * Finds out whether if any level property has changed
 * @param existingProperty - existing level property
 * @param newLevelProperty - updated level property
 * @returns boolean based on the changes detected
 */
const isLevelPropertiesUnchanged = (existingProperty, newLevelFeature) => {
    const keysToCompare = ['isMain', 'isOutdoor', 'zLevel'];
    const subset1 = (0, lodash_1.pick)(existingProperty, keysToCompare);
    const subset2 = (0, lodash_1.pick)(newLevelFeature.properties, keysToCompare);
    const existingName = existingProperty.names.find((n) => n.nameType === 'OFFICIAL');
    const newName = newLevelFeature.properties.names.find((n) => n.nameType === 'OFFICIAL');
    return ((0, lodash_1.isEqual)(subset1, subset2) && (0, lodash_1.isEqual)(existingName, newName) && !newLevelFeature.svgContent);
};
exports.isLevelPropertiesUnchanged = isLevelPropertiesUnchanged;
/**
* Update the properties of the existing levels (excluding SVG).
* @param momCollection - Updated mom collection
* @param levelProperties - Array of properties (i.e. index, name, type) for modified levels.
* @param metaData - User information
* @param existingMOM - Existing mom collection
* returns updatedMomCollection - Updated mom collection with new properties
*/
const updateLevelProperties = (momCollection, levelProperties, metaData, existingMom) => {
    const levelPropertiesObject = (0, lodash_1.mapValues)((0, lodash_1.keyBy)(levelProperties, 'id'), ({ properties, svgContent }) => ({ properties, svgContent }));
    const existingLevels = (0, lodash_1.filter)(existingMom?.features, { momType: 'indoor.Level' });
    momCollection.features.forEach((f) => {
        if (levelPropertiesObject[f.id]) {
            const existingLevel = (0, lodash_1.find)(existingLevels, { id: f.id });
            if (existingLevel && !(0, exports.isLevelPropertiesUnchanged)(existingLevel.properties, levelPropertiesObject[f.id])) {
                (0, exports.patchDelta)(f.properties, 'UPDATED');
                (0, exports.patchMeta)(f.properties, metaData);
            }
            f.properties = { ...f.properties, ...levelPropertiesObject[f.id].properties };
        }
    });
};
exports.updateLevelProperties = updateLevelProperties;
/**
 * Updated the existing MOM collection with the new features
 * @param existingMOM - existing MOM with overrided features from the new MOM collection
 * @param modifiedMOM - modified MOM with newly added features
 * @returns updated MOM collection with new features added to it
 */
const addFeatures = (existingMOM, modifiedMOM) => {
    const newFeatures = new Set((0, lodash_1.map)(existingMOM.features, 'id'));
    const updatedFeatures = [];
    modifiedMOM.features.forEach((f) => {
        if (!newFeatures.has(f.id)) {
            (0, helper_1.logMsg)(`New featured added ${f.id}`);
            updatedFeatures.push(f);
        }
    });
    if (updatedFeatures.length === 0) {
        (0, helper_1.logMsg)('No new features found');
    }
    return updatedFeatures;
};
exports.addFeatures = addFeatures;
/**
 * to know if the provided main space has multiple child spaces under it
 * @param spaceGroup - space group feature
 * @param mainSpaceId  - main space Id
 * @returns if the main space has more than one child spaces
 */
const getMultiSpaceGroup = (spaceGroup, mainSpaceId) => {
    const spaceGroups = spaceGroup.properties.spaceGroups || [];
    const commonalityGroups = spaceGroup.properties.commonalityGroups || [];
    const selectedSpaceGroup = spaceGroups.find((sp) => sp.mainSpace.id === mainSpaceId);
    const selectedCommonalityGroup = commonalityGroups.find((sp) => sp.mainSpace.id === mainSpaceId);
    const isMultiSpace = {
        status: false,
        spaceList: [],
    };
    if (selectedSpaceGroup && selectedSpaceGroup.spaces && selectedSpaceGroup.spaces.length > 0) {
        const spaceIds = selectedSpaceGroup.spaces.map((sp) => sp.id);
        isMultiSpace.spaceList = spaceIds;
        isMultiSpace.status = true;
    }
    else if (selectedCommonalityGroup && selectedCommonalityGroup.spaces && selectedCommonalityGroup.spaces.length > 0) {
        const spaceIds = selectedCommonalityGroup.spaces.map((sp) => sp.id);
        isMultiSpace.spaceList = spaceIds;
        isMultiSpace.status = true;
    }
    return isMultiSpace;
};
const removeSpaceReferences = (existingFeature, removeFeature) => {
    switch (existingFeature.momType) {
        case 'indoor.Occupant':
            if (existingFeature.properties.spaces) {
                (0, lodash_1.remove)(existingFeature.properties.spaces, (space) => space.id === removeFeature.id);
            }
            break;
        case 'indoor.SpaceGroups':
            if (existingFeature.properties.spaceGroups) {
                existingFeature.properties.spaceGroups.forEach((spaceGroup) => {
                    if (spaceGroup.spaces.length <= 1) {
                        (0, lodash_1.remove)(existingFeature.properties.spaceGroups, (sp) => sp.spaces[0].id === removeFeature.id);
                    }
                    else {
                        (0, lodash_1.remove)(spaceGroup.spaces, (space) => space.id === removeFeature.id);
                    }
                    // To remove across level space groups when main spaceid is removed
                    (0, lodash_1.remove)(existingFeature.properties.spaceGroups, (sp) => sp.spaceGroupId === removeFeature.id);
                });
            }
            if (existingFeature.properties.commonalityGroups) {
                existingFeature.properties.commonalityGroups.forEach((commonalityGroup) => {
                    if (commonalityGroup.spaces.length <= 1) {
                        (0, lodash_1.remove)(existingFeature.properties.commonalityGroups, (commonality) => commonality.spaces[0].id === removeFeature.id);
                    }
                    else
                        (0, lodash_1.remove)(commonalityGroup.spaces, (space) => space.id === removeFeature.id);
                });
            }
            break;
    }
};
/**
 * Updates the mpa geometry with recalculated outline
 * @param existingMOMCollection - original feature collection
 * @param mpasToBeUpdated - array of mpas to be updated
 * @param metaData - user information
 */
const updateMPAGeometry = (existingMOMCollection, mpasToBeUpdated, metaData, status) => {
    existingMOMCollection.features.forEach((feature) => {
        // find the mpa which needs to be modified and update the geometry and delta flag accordingly
        const selectedMPA = mpasToBeUpdated.find((mpa) => mpa.id === feature.id);
        if (selectedMPA) {
            (0, exports.patchDelta)(feature.properties, status);
            (0, exports.patchMeta)(feature.properties, metaData);
            if (selectedMPA.geometry) {
                feature.referencePoint = selectedMPA.geometry;
                feature.geometry = selectedMPA.geometry;
            }
        }
    });
};
exports.updateMPAGeometry = updateMPAGeometry;
/**
 * Updates the parking section geometries based on the parking spots
 * @param momCollection - mom collection data
 * @param levelIds - level ids which needs to be used to filter data
 * @param metaData - user information
 */
const resizeSpaceSections = (momCollection, levelIds, metaData) => {
    // space groups filtered based on the level
    const filteredSpaceGroups = (0, lodash_1.filter)(momCollection.features, (f) => f.momType === 'indoor.SpaceGroups' &&
        f.properties.level && levelIds.includes(f.properties.level.id));
    const spaceGroupMap = new Map();
    const childFeaturesMap = new Map();
    const parentMpaMap = new Map();
    const flattenedChildSpaceIds = [];
    // get mapping of parent space with child spaces
    (0, lodash_1.forEach)(filteredSpaceGroups, (sp) => {
        const spaceGroups = sp.properties.spaceGroups;
        const commonalityGroups = sp.properties.commonalityGroups;
        if (spaceGroups) {
            (0, lodash_1.forEach)(spaceGroups, (sg) => {
                flattenedChildSpaceIds.push(...sg.spaces.map((space) => space.id));
                spaceGroupMap.set(sg.mainSpace.id, sg.spaces);
            });
        }
        if (commonalityGroups) {
            (0, lodash_1.forEach)(commonalityGroups, (sg) => {
                flattenedChildSpaceIds.push(...sg.spaces.map((space) => space.id));
                spaceGroupMap.set(sg.mainSpace.id, sg.spaces);
            });
        }
    });
    // get child features mapping wth parent ids
    (0, lodash_1.forEach)(momCollection.features, (f) => {
        if (flattenedChildSpaceIds.includes(f.id)) {
            const parentSpace = f.properties.parentSpace;
            const childFeatures = childFeaturesMap.get(parentSpace.id) || [];
            childFeatures.push(f);
            childFeaturesMap.set(parentSpace.id, childFeatures);
        }
    });
    // resizing the parent space geometries
    (0, lodash_1.forEach)(momCollection.features, (f) => {
        if (childFeaturesMap.has(f.id)) {
            const recalculatedOutline = (0, exports.calculateOutlineGeometry)(childFeaturesMap.get(f.id));
            const recalculatedReferencePoint = (0, exports.calculateReferencePoint)(recalculatedOutline);
            f.geometry = recalculatedOutline;
            f.referencePoint = recalculatedReferencePoint;
            const parentSpaceMPA = f.properties.spaceAddress;
            if (parentSpaceMPA) {
                parentMpaMap.set(parentSpaceMPA.id, recalculatedReferencePoint);
            }
        }
    });
    // updating the MPA geometries connected to parentspace
    (0, lodash_1.forEach)(momCollection.features, (f) => {
        if (parentMpaMap.has(f.id)) {
            f.geometry = parentMpaMap.get(f.id);
            f.referencePoint = parentMpaMap.get(f.id);
            (0, exports.patchDelta)(f.properties, 'UPDATED');
            (0, exports.patchMeta)(f.properties, metaData);
        }
    });
};
exports.resizeSpaceSections = resizeSpaceSections;
/**
 * to remove only occupant and space group references when color code is changed
 * @param existingMOMCollection  - existing MOM collection
 * @param removableReferences  - the space features whose references needs to be removed
 */
const removeOnlyReferences = (existingMOMCollection, removableReferences, metaData) => {
    removableReferences.forEach((ref) => {
        existingMOMCollection.features.forEach((feature) => {
            switch (feature.momType) {
                case 'indoor.Occupant':
                    removeSpaceReferences(feature, ref);
                    break;
                case 'indoor.SpaceGroups': {
                    const parentSpaceFeature = ref.properties.parentSpace;
                    if (parentSpaceFeature) {
                        // for space groups on same level
                        const levelId = ref.properties.level.id;
                        if (feature.properties.level &&
                            feature.properties.level.id === levelId) {
                            removeSpaceReferences(feature, ref);
                            // to know if the main space has multiple children
                            const multiSpaceGroup = getMultiSpaceGroup(feature, parentSpaceFeature.id);
                            if (!multiSpaceGroup.status) {
                                // soft delete the main space
                                existingMOMCollection.features.forEach((f) => {
                                    if (f.id === parentSpaceFeature.id) {
                                        // Remove the parent space MPA if present
                                        const parentSpaceMpa = f.properties.spaceAddress;
                                        if (parentSpaceMpa) {
                                            (0, exports.updateMPAGeometry)(existingMOMCollection, [{ ...parentSpaceMpa }], metaData, 'REMOVED');
                                        }
                                        (0, exports.patchDelta)(f.properties, 'REMOVED');
                                        (0, exports.patchMeta)(f.properties, metaData);
                                        // recursively calling the function for cases when main space is part of another
                                        // space group (possible only when it's split)
                                        (0, exports.removeOnlyReferences)(existingMOMCollection, [{ ...f }], metaData);
                                    }
                                });
                            }
                        }
                    }
                    else if (!parentSpaceFeature && !feature.properties.level) {
                        // for space groups across levels
                        removeSpaceReferences(feature, ref);
                    }
                    break;
                }
                case 'Address':
                    if (ref.properties.spaceAddress?.id === feature.id || ref.properties.address?.id === feature.id) {
                        (0, exports.patchDelta)(feature.properties, 'REMOVED');
                        (0, exports.patchMeta)(feature.properties, metaData);
                        if (feature.properties?.parentPointAddressId?.id) {
                            feature.properties.parentPointAddressId = { id: 'not_available' };
                        }
                        delete feature.properties.routingPoints;
                        delete feature.properties.locationDetails;
                        delete feature.properties.otherDisplayPoints;
                        delete feature.properties.parentMicroPointAddressId;
                    }
                    break;
                case 'indoor.LevelConnector':
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    (0, exports.removeLevelConnectorReferences)(feature, ref, existingMOMCollection, metaData);
                    break;
                case 'indoor.Level':
                case 'Topology':
                    if (ref.id === feature.id) {
                        (0, exports.patchDelta)(feature.properties, 'REMOVED');
                        (0, exports.patchMeta)(feature.properties, metaData);
                    }
                    break;
                default:
                    break;
            }
        });
    });
};
exports.removeOnlyReferences = removeOnlyReferences;
const deleteTopologyById = (existingMOMCollection, topologyId, metaData) => {
    const topologyToDelete = existingMOMCollection.features.find((topology) => topology.id === topologyId);
    (0, exports.patchDelta)(topologyToDelete.properties, 'REMOVED');
    (0, exports.patchMeta)(topologyToDelete.properties, metaData);
    (0, lodash_1.filter)(existingMOMCollection.features, { momType: 'indoor.Level' }).forEach((level) => {
        (0, lodash_1.remove)(level.properties.topologies, (topology) => topology.id === topologyId);
    });
    return existingMOMCollection;
};
const getSpaceLevelIds = (existingMOMCollection, spaces) => {
    const spaceLevelIdsArray = [];
    spaces.forEach((space) => {
        spaceLevelIdsArray.push({
            spaceId: space,
            levelId: (0, lodash_1.find)(existingMOMCollection.features, { id: space }).properties.level.id,
        });
    });
    return spaceLevelIdsArray;
};
/**
 * It will delete all the references of Level connector feature as below
 * Soft delete space itself
 * Remove its reference from indoor.LevelConnector feature
 * Remove its corresponding connecting topologies and hanging spaces if any
 * Soft delete above topologies and its reference from Level object
 * Soft delete indoor.LevelConnector feature itself if there are less than 2 spaces listed
 * @param existingFeature indoor.LevelConnector feature from which we need to delete all the removedFeature references
 * @param removeFeature any Space feature like Stairs/Elevator
 * @param existingMOMCollection entire MOM data
 */
const removeLevelConnectorReferences = (existingFeature, removeFeature, existingMOMCollection, metaData) => {
    let removedSpaceIds = [];
    if (existingFeature.properties && existingFeature.properties?.spaces) {
        removedSpaceIds = (0, lodash_1.remove)(existingFeature.properties.spaces, (space) => space.id === removeFeature.id);
    }
    if (removedSpaceIds.length > 0) {
        if (existingFeature.properties.connectingTopologies?.length) {
            const removedFeatureLevelId = removeFeature.properties.level?.id;
            const removedconnectingTopologies = (0, lodash_1.remove)(existingFeature.properties.connectingTopologies, (connectedTopology) => removedFeatureLevelId === connectedTopology.levels[0].id || removedFeatureLevelId === connectedTopology.levels[1].id);
            removedconnectingTopologies.forEach((connectedTopology) => {
                deleteTopologyById(existingMOMCollection, connectedTopology?.topology?.id, metaData);
            });
            const spaceLevelIdsArray = getSpaceLevelIds(existingMOMCollection, existingFeature.properties.spaces?.map((space) => space.id));
            spaceLevelIdsArray.forEach((spaceLevelIds) => {
                let levelFound = false;
                for (let i = 0; i < existingFeature.properties?.connectingTopologies?.length; i += 1) {
                    if (spaceLevelIds.levelId === existingFeature.properties?.connectingTopologies[i].levels[0].id ||
                        spaceLevelIds.levelId === existingFeature.properties?.connectingTopologies[i].levels[1].id) {
                        levelFound = true;
                        break;
                    }
                }
                if (!levelFound) {
                    (0, lodash_1.remove)(existingFeature.properties.spaces, (space) => space.id === spaceLevelIds.spaceId);
                }
            });
        }
    }
    if (existingFeature.properties.spaces.length < 2) {
        (0, exports.patchDelta)(existingFeature.properties, 'REMOVED');
        (0, exports.patchMeta)(existingFeature.properties, metaData);
    }
};
exports.removeLevelConnectorReferences = removeLevelConnectorReferences;
/**
* @desc - To delete the spaces/ entrance/ exit from the existing MOM collection for which the level has been deleted.
* @param1 existingMOMCollection - Input mom collection with all levels.
* @param2 feature - Feature which is to be deleted
* returns updatedMomCollection - Updated MOM collection with deleted spaces.
*/
function deleteSpacesOrEntrances(existingMOMCollection, removeFeature, metaData) {
    existingMOMCollection.features.forEach((existingFeature) => {
        if (existingFeature.id === removeFeature.id) {
            (0, exports.patchDelta)(existingFeature.properties, 'REMOVED');
            (0, exports.patchMeta)(existingFeature.properties, metaData);
        }
    });
    // Return the updated MOM collection which does not consist of spaces or entrances from deleted level.
    return existingMOMCollection;
}
/**
* @desc - To delete a feature from a level.
* @param1 existingMOMCollection - Existing space features for edited level.
* @param2 feature - Feature which is to be deleted
* returns updatedMOMCollection - Updated space features array with removed/ modified spaces geometries/ properties.
*/
const deleteFeatures = (existingMOMCollection, featuresToDelete, metaData) => {
    featuresToDelete.forEach((feature) => {
        switch (feature.momType) {
            case 'indoor.Space':
            case 'indoor.Entrance':
                deleteSpacesOrEntrances(existingMOMCollection, feature, metaData);
                break;
        }
    });
    (0, exports.removeOnlyReferences)(existingMOMCollection, featuresToDelete, metaData);
    // Return the updated features array with removed/ modified geometries/ properties.
    return existingMOMCollection;
};
exports.deleteFeatures = deleteFeatures;
/**
 * @param point1 - The first point
 * @param point2 - The second point
 * return boolean value based on the distance if surpasses the minimum defined threshold
 */
const isSpaceGeometryChanged = (point1, point2) => {
    const distanceBetweenPoints = Math.abs((0, distance_1.default)(point1, point2, { units: 'centimeters' }));
    return distanceBetweenPoints > constants_1.MINIMUM_DEVIATION_THRESHOLD;
};
exports.isSpaceGeometryChanged = isSpaceGeometryChanged;
/**
 * @param levelId  - Level id string
 * @param levelProperties  - Level Properties array with svg information
 * @returns filename associated of selected level id
 */
const getFileNameForLevel = (levelId, levelProperties) => {
    const selectedLevel = levelProperties.find((level) => level.id === levelId);
    const fileName = selectedLevel?.fileName || selectedLevel?.svgPath || '';
    return fileName;
};
exports.getFileNameForLevel = getFileNameForLevel;
/**
 * Override space geometries and their reference points
 * @param existingMOM - original feature collection
 * @param modifiedMOM - modified feature collection with new geometries
 * returns updatedMOMCollection - modified feature collection with recalculated geometries & features to be deleted
 */
const updateLevelSpaces = (existingMOM, modifiedMOM, metaData, levelProperties, logs, colorRules) => {
    const newFeaturesGeometry = {};
    const featuresToDelete = [];
    modifiedMOM.features.forEach((f) => {
        newFeaturesGeometry[f.id] = {
            momType: f.momType,
            geometry: f.geometry,
            referencePoint: f.referencePoint,
            properties: f.properties,
        };
    });
    const updatedMomCollection = {
        type: 'FeatureCollection',
        features: [],
    };
    const removableSpaceReferences = [];
    const mpasToBeModified = [];
    existingMOM.features.forEach((existingFeature) => {
        if (newFeaturesGeometry[existingFeature.id]) {
            const modifiedFeature = (0, lodash_1.cloneDeep)(existingFeature);
            // to revert the deleted feature when found in reimported SVG
            if ((0, exports.getDeltaChangeState)(existingFeature.properties) === 'REMOVED') {
                // Reseting the space properties when reimporting deleted spaces
                modifiedFeature.properties = newFeaturesGeometry[existingFeature.id].properties;
                (0, exports.patchDelta)(existingFeature.properties, 'UPDATED');
                (0, exports.patchMeta)(existingFeature.properties, metaData, modifiedFeature.properties);
            }
            // throw error if entrance is converted to space or vice versa
            if (newFeaturesGeometry[existingFeature.id].momType !== existingFeature.momType) {
                const fileName = (0, exports.getFileNameForLevel)(existingFeature.properties.level.id, levelProperties);
                (0, exports.formatLogs)(fileName, { errors: [`Indoor momType is different than the previous version for feature='${existingFeature.id}'`] }, logs);
            }
            // eslint-disable-next-line max-len
            if (!colorRules || !colorRules.skipInUpdateProcess?.includes(`${newFeaturesGeometry[existingFeature.id].properties.spaceCategory}.${newFeaturesGeometry[existingFeature.id].properties.spaceType}`)) {
                // Override geometry and reference point as per new conversion except for Unknown object space
                if ((0, exports.isSpaceGeometryChanged)(newFeaturesGeometry[existingFeature.id].referencePoint, existingFeature.referencePoint)) {
                    (0, exports.patchDelta)(modifiedFeature.properties, 'UPDATED');
                    (0, exports.patchMeta)(existingFeature.properties, metaData, modifiedFeature.properties);
                    let microPointAddress = null;
                    if (existingFeature.momType === 'indoor.Space') {
                        microPointAddress = { ...existingFeature.properties.spaceAddress };
                    }
                    else {
                        // handling for other scenarios such as entrances
                        microPointAddress = { ...existingFeature.properties.address };
                    }
                    // modify micro point address geometry when space geometry is modified
                    if (microPointAddress) {
                        // maintaining track of space reference point to update in MPA
                        microPointAddress.geometry = newFeaturesGeometry[existingFeature.id].referencePoint;
                        mpasToBeModified.push(microPointAddress);
                    }
                }
                modifiedFeature.geometry = newFeaturesGeometry[existingFeature.id].geometry || existingFeature.geometry;
                modifiedFeature.referencePoint = newFeaturesGeometry[existingFeature.id].referencePoint || existingFeature.referencePoint;
            }
            if (existingFeature.momType === 'indoor.Space') {
                modifiedFeature.properties.drawOrder = newFeaturesGeometry[existingFeature.id].properties.drawOrder;
                modifiedFeature.properties.stackIndex = newFeaturesGeometry[existingFeature.id].properties.stackIndex;
                if ((!(0, lodash_1.isEqual)(existingFeature.properties.spaceType, newFeaturesGeometry[existingFeature.id].properties.spaceType) ||
                    !(0, lodash_1.isEqual)(existingFeature.properties.spaceCategory, newFeaturesGeometry[existingFeature.id].properties.spaceCategory)) &&
                    // eslint-disable-next-line max-len
                    (!colorRules || !colorRules.skipInUpdateProcess?.includes(`${newFeaturesGeometry[existingFeature.id].properties.spaceCategory}.${newFeaturesGeometry[existingFeature.id].properties.spaceType}`))) {
                    /**
                    If either of properties, i.e. spaceType or spaceCategory miss matches,
                    Remove the references & update the Space configurations
                    Note: Skip this for Unknown object space
                    */
                    removableSpaceReferences.push({ ...existingFeature });
                    modifiedFeature.properties = newFeaturesGeometry[existingFeature.id].properties;
                    (0, exports.patchDelta)(modifiedFeature.properties, 'UPDATED');
                    (0, exports.patchMeta)(existingFeature.properties, metaData, modifiedFeature.properties);
                }
            }
            updatedMomCollection.features.push(modifiedFeature);
            // eslint-disable-next-line max-len
        }
        else if ((colorRules && colorRules.skipSpaceFeature.includes(`${existingFeature.properties.spaceCategory}.${existingFeature.properties.spaceType}`)) || existingFeature.momType === 'indoor.SpaceGroups') {
            /**
            to prevent deletion of space groups and parking section features since they wont be the part of modified feature collection
            */
            updatedMomCollection.features.push(existingFeature);
        }
        else {
            /* if reached else means that the feature is not present in the modified collection,
             it means that the feature is deleted, call delete references function from here */
            updatedMomCollection.features.push(existingFeature);
            featuresToDelete.push(existingFeature);
        }
    });
    const newlyAddedFeatures = (0, exports.addFeatures)(updatedMomCollection, modifiedMOM);
    updatedMomCollection.features = updatedMomCollection.features.concat(newlyAddedFeatures);
    return { updatedFeatureCollection: updatedMomCollection, featuresToDelete, removableSpaceReferences, mpasToBeModified };
};
exports.updateLevelSpaces = updateLevelSpaces;
const updateLevels = (existingMOM, modifiedMOM, updatedlevelIds, metaData, levelProperties, logs, colorRules) => {
    const updatedLevelFeatures = { type: 'FeatureCollection', features: [] };
    const featuresToDeleteInExistingMom = [];
    const removableSpaceReferencesInExistingMom = [];
    const mpaGeometriesToBeModified = [];
    for (let i = 0; i < updatedlevelIds.length; i += 1) {
        const existingLevelFeatures = { type: 'FeatureCollection', features: (0, exports.getLevelFeaturesByLevelId)(existingMOM, updatedlevelIds[i]) };
        const modifiedLevelFeatures = { type: 'FeatureCollection', features: (0, exports.getLevelFeaturesByLevelId)(modifiedMOM, updatedlevelIds[i]) };
        const { updatedFeatureCollection, featuresToDelete, removableSpaceReferences, mpasToBeModified } = (0, exports.updateLevelSpaces)(existingLevelFeatures, modifiedLevelFeatures, metaData, levelProperties, logs, colorRules);
        updatedLevelFeatures.features.push(...updatedFeatureCollection.features);
        featuresToDeleteInExistingMom.push(...featuresToDelete);
        removableSpaceReferencesInExistingMom.push(...removableSpaceReferences);
        mpaGeometriesToBeModified.push(...mpasToBeModified);
    }
    return {
        updatedFeatureCollection: updatedLevelFeatures,
        featuresToDelete: featuresToDeleteInExistingMom,
        removableSpaceReferences: removableSpaceReferencesInExistingMom,
        mpasToBeModified: mpaGeometriesToBeModified,
    };
};
exports.updateLevels = updateLevels;
const addLevels = (momData, levelIds) => {
    const levelFeatures = { type: 'FeatureCollection', features: [] };
    for (let i = 0; i < levelIds.length; i += 1) {
        levelFeatures.features.push(...(0, exports.getLevelFeaturesByLevelId)(momData, levelIds[i]));
    }
    return levelFeatures;
};
exports.addLevels = addLevels;
/**
 * @param1 momCollection - the mom collection
 * @param2 topologyIds - the topology ids to fetch features
 * returns array of the topology features
 */
const getTopologiesForLevel = (momCollection, topologyReferences) => {
    const topologyIds = topologyReferences.map(({ id }) => id);
    return (0, lodash_1.filter)(momCollection.features, ({ id }) => topologyIds.includes(id));
};
exports.getTopologiesForLevel = getTopologiesForLevel;
/**
* To delete the levels from the existing MOM collection for the provided level ids and delete their traces as well.
* @param1 momCollection - Existing MOM collection
* @param2 deletedLevelIds - Array of level ids which needs to be deleted.
* updates the momCollection with deleted levels.
*/
const deleteLevels = (momCollection, deletedLevelIds, metaData) => {
    deletedLevelIds.forEach((levelId) => {
        const levelFeatures = (0, exports.getLevelFeaturesByLevelId)(momCollection, levelId);
        const level = (0, lodash_1.find)(levelFeatures, { id: levelId });
        const topologyIds = level.properties.topologies || [];
        const topologies = (0, exports.getTopologiesForLevel)(momCollection, topologyIds);
        const featuresToDelete = [...topologies, ...levelFeatures];
        (0, exports.deleteFeatures)(momCollection, featuresToDelete, metaData);
    });
};
exports.deleteLevels = deleteLevels;
/**
 * Recalculation of site and structure geometries based on the modified space geometries
 * @param momCollection - modified space geometries mom collection
 * @param existingMOM - existing features mom collection
 * @param metaData - user meta information
 * @param currentStructureId - current structure id
 * updates the momCollection with the recalculated site and structure geometries
 */
const recalculateSiteAndStructureBoundaries = (momCollection, existingMOM, metaData, currentStructureId) => {
    // filtering current structure first from existing MOM since need previous user information,
    //  if newly added then will find it in the new momCollection
    const currentStructure = (0, lodash_1.find)(existingMOM.features, { id: currentStructureId }) ||
        (0, lodash_1.find)(momCollection.features, { id: currentStructureId });
    // filter levels corresponding to current structure
    const filteredLevels = momCollection.features.filter((feature) => feature.momType === 'indoor.Level' &&
        feature.properties.structure.id === currentStructureId &&
        feature.properties['@ns:com:here:mom:delta']?.changeState !== 'REMOVED');
    // create structure feature properties
    const structureFeature = (0, exports.createStructureFeature)((currentStructure).id, filteredLevels, currentStructure.properties);
    (0, exports.patchDelta)((structureFeature).properties, 'UPDATED');
    (0, exports.patchMeta)((structureFeature).properties, metaData);
    const structureIndex = (0, lodash_1.findIndex)(momCollection.features, { id: currentStructureId });
    momCollection.features[structureIndex] = structureFeature;
    // Updating current structure MPA geometry and ref point
    const currentStructureMPA = (0, lodash_1.find)(existingMOM.features, { id: currentStructure.properties.address?.id }) ||
        (0, lodash_1.find)(momCollection.features, { id: currentStructure.properties.address?.id });
    if (currentStructureMPA) {
        currentStructureMPA.geometry = structureFeature.referencePoint;
        currentStructureMPA.referencePoint = structureFeature.referencePoint;
    }
    const currentStructureMPAIndex = (0, lodash_1.findIndex)(momCollection.features, { id: currentStructure.properties.address?.id });
    momCollection.features[currentStructureMPAIndex] = currentStructureMPA;
    const existingSite = (0, lodash_1.find)(existingMOM.features, { momType: 'indoor.Site' });
    const siteData = (0, lodash_1.find)(momCollection.features, { momType: 'indoor.Site' });
    (0, exports.patchDelta)(existingSite.properties, 'UPDATED');
    (0, exports.patchMeta)(existingSite.properties, metaData);
    // recalculate site geometry
    const updatedSite = (0, exports.createSiteFeature)(siteData.id, (0, lodash_1.filter)(momCollection.features, { momType: 'indoor.Structure' }), existingSite.properties);
    // overwrite in the existing MOM collection
    const siteIndex = (0, lodash_1.findIndex)(momCollection.features, { momType: 'indoor.Site' });
    momCollection.features[siteIndex] = updatedSite;
};
exports.recalculateSiteAndStructureBoundaries = recalculateSiteAndStructureBoundaries;
/**
 * It will check for any duplicate feature id's generated in the given MOM data
 * @param momFeatureCollection
 * @param levelFeatures level objects provided by UI
 * @returns duplicate feature id's by level names
 */
const checkForDuplicateFeatureIds = (momFeatureCollection, levelFeatures) => {
    const duplicateFeatures = (0, lodash_1.chain)(momFeatureCollection.features)
        .groupBy((feature) => feature.id)
        .reduce((currentFeatureArray, featureArray) => {
        if (featureArray.length > 1)
            currentFeatureArray.push((0, lodash_1.last)(featureArray));
        return currentFeatureArray;
    }, []).value();
    let duplicateFeaturesByLevel = [];
    if (duplicateFeatures.length > 0) {
        duplicateFeaturesByLevel = (0, lodash_1.chain)(duplicateFeatures).groupBy('properties.level.id')
            .map((value, key) => ({
            levelName: (levelFeatures?.find((l) => l.id === key)?.fileName || levelFeatures?.find((l) => l.id === key)?.svgPath),
            duplicateFeatureIds: value.map((feature) => feature.id),
        }))?.value();
    }
    return duplicateFeaturesByLevel;
};
exports.checkForDuplicateFeatureIds = checkForDuplicateFeatureIds;
const deepEqualObjects = (obj1, obj2) => {
    if (obj1 === obj2) {
        return true;
    }
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        if (!keys2.includes(key) || !(0, exports.deepEqualObjects)(obj1[key], obj2[key])) {
            if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
                // If the current values are arrays, compare them regardless of order
                if (obj1[key].length !== obj2[key].length ||
                    !obj1[key].every((elem) => obj2[key].includes(elem))) {
                    return false;
                }
            }
            else {
                return false;
            }
        }
    }
    return true;
};
exports.deepEqualObjects = deepEqualObjects;
/**
 * To format the level properties as per schema
 * @param levelProperties - Level properties array
 * @returns formated level information
 */
const mapSvgFileContents = (levelProperties) => {
    const levelsWithSvgContent = [];
    levelProperties.forEach((level) => {
        const currentLevelSvg = {
            levelName: level.properties.names.find((n) => n.nameType === 'OFFICIAL')?.name,
            levelId: level.id,
            svgString: level.svgContent,
            isDeleted: !!level.isDeleted,
        };
        levelsWithSvgContent.push(currentLevelSvg);
    });
    return levelsWithSvgContent;
};
exports.mapSvgFileContents = mapSvgFileContents;
const hasDuplicates = (array) => (0, lodash_1.uniqWith)(array, lodash_1.isEqual).length !== array.length;
exports.hasDuplicates = hasDuplicates;
/**
 * To get count of space category and type
 * @param spacesData - space array
 * @returns count of space category and type
 */
const getspaceCatTypeCount = (spacesData) => {
    const report = {};
    spacesData.forEach((momObj) => {
        const momSpaceCat = momObj.properties.spaceCategory;
        const momSpaceType = momObj.properties.spaceType;
        if (!report[momSpaceCat]) {
            report[momSpaceCat] = {};
        }
        if (!report[momSpaceCat][momSpaceType]) {
            report[momSpaceCat][momSpaceType] = 0;
        }
        report[momSpaceCat][momSpaceType] += 1;
    });
    return report;
};
exports.getspaceCatTypeCount = getspaceCatTypeCount;
/**
 * To get count of parking restrictions count
 * @param spacesData - space array
 * @returns count of of parking restrictions count
 */
const getParkingRestrictionsCount = (spacesData) => {
    const report = {
        isDisabledAccess: 0,
        isRestrictedArea: 0,
        boxed: 0,
        category: 0,
        reservation: 0,
        sizeCategory: 0,
        hasEvChargingAccess: 0,
    };
    spacesData.forEach((space) => {
        if (space.properties.spaceTypeProperties?.isDisabledAccess) {
            report.isDisabledAccess += 1;
        }
        if (space.properties.spaceTypeProperties?.isRestrictedArea) {
            report.isRestrictedArea += 1;
        }
        if (space.properties.spaceTypeProperties?.parkingTypeProperties?.boxed) {
            report.boxed += 1;
        }
        if (space.properties.spaceTypeProperties?.parkingTypeProperties?.category) {
            report.category += 1;
        }
        if (space.properties.spaceTypeProperties?.parkingTypeProperties?.reservation) {
            report.reservation += 1;
        }
        if (space.properties.spaceTypeProperties?.parkingTypeProperties?.sizeCategory) {
            report.sizeCategory += 1;
        }
        if (space.properties.spaceTypeProperties?.parkingTypeProperties?.evCharging?.hasEvChargingAccess) {
            report.hasEvChargingAccess += 1;
        }
    });
    return report;
};
exports.getParkingRestrictionsCount = getParkingRestrictionsCount;
/**
 * To get count of space groups
 * @param spacesData - space array
 * @returns count of space groups
 */
const getSpaceGroupsCount = (spacesData) => {
    const report = {
        byProperty: 0,
        byLocation: 0,
    };
    spacesData.forEach((spaceGroup) => {
        report.byProperty += spaceGroup.properties.commonalityGroups ? spaceGroup.properties.commonalityGroups.length : 0;
        report.byLocation += spaceGroup.properties.spaceGroups ? spaceGroup.properties.spaceGroups.length : 0;
    });
    return report;
};
exports.getSpaceGroupsCount = getSpaceGroupsCount;
/**
 * To get count of occupant and its related attributes
 * @param spacesData - space array
 * @returns count of occupant and its related attributes
 */
const getOccupantAttributes = (occupantData) => {
    const report = {
        contactEmail: 0,
        contactPhone: 0,
        contactUrl: 0,
    };
    report.occupants = occupantData.length;
    const occupantPropArr = occupantData.flatMap((feature) => feature.properties.placeProperties.contacts).filter((feature) => !!feature);
    occupantPropArr.forEach((prop) => {
        if (prop.contactType && prop.contactType === 'PHONE') {
            report.contactPhone += 1;
        }
        if (prop.contactType && prop.contactType === 'EMAIL') {
            report.contactEmail += 1;
        }
        if (prop.contactType && prop.contactType === 'URL') {
            report.contactUrl += 1;
        }
    });
    return report;
};
exports.getOccupantAttributes = getOccupantAttributes;
exports.testExports = {
    getLargestTriangle,
};
